import React from 'react';
import { withAppConfig } from '../../../../../../../../appConfigContext';
import { inject } from 'mobx-react';
import { compose } from 'recompose';
import ADEException from './ADEExceptionFlow/utils';
import DefaultException from './DefaultExceptionFlow/utils';
import BothException from './BothExceptionFlow/utils';
import { checkIfDefaultExceptionFlow, checkIfBothExceptionFlow, parseExceptionConfig, getExceptionNumberLabel } from './utils';

export function withExceptionDetailsHOC(Component) {
  const WrappedComponent = (props) => {
    const exceptionConfig = parseExceptionConfig(props.configJSON?.exceptionConfig);
    const exceptionFlow = exceptionConfig?.exceptionFlow;

    const isDefaultExceptionFlow = checkIfDefaultExceptionFlow(exceptionFlow);
    const isBothExceptionFlow = checkIfBothExceptionFlow(exceptionFlow);
    const minExceptionNumberLength = exceptionConfig?.minExceptionNumberLength;
    const maxExceptionNumberLength = exceptionConfig?.maxExceptionNumberLength;

    // DispatchStore is now available via inject
    const exceptionNumberLabel = getExceptionNumberLabel(props.DispatchStore);
    let deliveryException;

    const exceptionConfigForUtils = {
      minExceptionNumberLength,
      maxExceptionNumberLength,
      exceptionNumberLabel
    };
    if (isBothExceptionFlow) {
      deliveryException = BothException(exceptionConfigForUtils);
    } else if (isDefaultExceptionFlow) {
      deliveryException = DefaultException;
    } else {
      deliveryException = ADEException(exceptionConfigForUtils);
    }

    return (
      <Component
        {...props}
        deliveryException={deliveryException}
        exceptionConfig={exceptionConfig}
        exceptionFlow={exceptionFlow}
        maxExceptionNumberLength={maxExceptionNumberLength}
        exceptionNumberLabel={exceptionNumberLabel}
      />
    );
  };

  // Inject DispatchStore and wrap with AppConfig
  return compose(
    inject('DispatchStore'),
    withAppConfig
  )(WrappedComponent);
}
